export default __webpack_public_path__ + "static/media/640.94999570.jpg";